import React from "react";
import Box from "@mui/material/Box";
import { Fade } from "@mui/material";

// Tappable follow-up suggestion chips shown above the chat input.
// Used both for server-provided `suggestions` and the local keyword
// heuristics fallback.
const SuggestionChips = ({ suggestions, onSuggestionClick, show = true }) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <Fade in={show} timeout={250}>
      <Box sx={{ marginTop: "10px", display: "flex", flexWrap: "wrap", gap: 0.75 }}>
        {suggestions.map((suggestion) => (
          <Box
            key={suggestion}
            role="button"
            onClick={() => onSuggestionClick(suggestion)}
            sx={{
              padding: "5px 11px",
              backgroundColor: "#f1f5f9",
              border: "1px solid #e2e8f0",
              borderRadius: "20px",
              cursor: "pointer",
              fontSize: "0.78rem",
              color: "#475569",
              transition: "all 0.15s ease",
              "&:hover": {
                backgroundColor: "#eef2ff",
                borderColor: "#c7d2fe",
                color: "#4338ca",
                transform: "translateY(-1px)",
              },
            }}
          >
            {suggestion}
          </Box>
        ))}
      </Box>
    </Fade>
  );
};

export default SuggestionChips;
